/**
 * Detects whether the app is running as an installed app: Android/desktop PWA,
 * a Trusted Web Activity (Play Store build) or an iOS home-screen app.
 * Normal browser tabs return false.
 */
export function isStandaloneDisplay(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const mm = window.matchMedia;
    const standalone =
      mm?.("(display-mode: standalone)").matches ||
      mm?.("(display-mode: fullscreen)").matches ||
      mm?.("(display-mode: minimal-ui)").matches ||
      // @ts-ignore iOS Safari
      window.navigator.standalone === true;
    // Trusted Web Activity always launches with the android-app referrer.
    const isTwa = document.referrer.startsWith("android-app://");
    return Boolean(standalone || isTwa);
  } catch {
    return false;
  }
}
